import { EMPLOYEE_RESOURCE_CODES_API } from 'config/constants';

// Bills
export const BILLS_ENDPOINTS = {
  // GET
  GET_BILLS: '/bills/list/',
  GET_BILL_SETTINGS: '/bills/settings/get/',
  GET_PREVIOUS_BILLS: '/bills/previous_bills/',
  // POST
  CREATE_BILL: '/bills/create/',
  CREATE_BILL_SETTINGS: '/bills/settings/save/',
  FETCH_SUMMARY: '/bills/summary/',
  APPROVE_BILLS: '/bills/approve/',
  // DELETE
  DELETE_BILL: '/bills/delete/',
  //SCAN_BILLS
  SCAN_BILLS: '/v1.1/api-bills/bills_ocr/',
  GET_SCANNED_BILL_AUDIT_LOGS: '/bills/import/scan_logs/',
  DISMISS_SCANNED_BILL_AUDIT_LOG: '/bills/import/scan_log/',
  BILL_DATA_REVIEWED: '/bills/reviewed/',
  // PERSIST_USER_FILTERS
  BILLS_USER_PERSIST: '/bills/user-persist/',
};

export const SUPPLIER_ENDPOINTS = {
  GET_SUPPLIER_DROPDOWN: '/v1.1/api-bills/dropdown/suppliers/',
  GET_SUPPLIERS: '/v1.1/supplier/get_suppliers/',
  CREATE_SUPPLIER: '/v1.1/supplier/',
  GET_SUPPLIER: '/v1.1/supplier/',
  GET_SUPPLIER_BY_ID: (id: string) => `/v1.1/supplier/${id}/`,
  UPDATE_SUPPLIER: '/v1.1/supplier',
  BULK_DELETE_SUPPLIER: `/v1.1/supplier/bulk_delete/`,
  BULK_ARCHIEVE_SUPPLIER: `/v1.1/supplier/bulk_archive/`,
  BULK_RESTORE_SUPPLIER: `/v1.1/supplier/restore/`,
  EXPORT_SUPPLIER: 'v1.1/supplier/bulk_export/',
  VALIDATE_IMPORT_SUPPLIER: 'v1.1/supplier/validate_supplier_sheet/',
  IMPORT_SUPPLIER: 'v1.1/supplier/bulkcreate/',
};

export const PROJECT_ENDPOINTS = {
  GET_PROJECT: '/project/',
  GET_PROJECT_DROPDOWN: '/v1.1/api-bills/dropdown/projects/',
  XERO_TRACKING_DROPDOWN: '/integration/xero_tracking_category/',
  SYNC_TRACKING_CATEGORIES: '/integration/sync_tracking_categories/',
  GET_PROJECT_SETTINGS: '/v1.2/bulk-project-setting/',
  GET_SUB_SEGMENTS: '/v1.1/project_drop_down_sub_segments/?id=',
};

export const TAX_SETTINGS_ENDPOINTS = {
  GET_TAX_SETTINGS_DROPDOWN: '/v1.1/api-bills/dropdown/tax_list/',
};

export const DOCKET_ENDPOINTS = {
  GET_DOCKET_DROPDOWN: '/v1.1/api-bills/dropdown/dockets',
  GET_DOCKET_DETAILS: '/v1.1/api-bills/dropdown/docket_details',
  GET_PO_DOCKETS_PAID_STATUS: '/bills/docket_and_purchase_order_paid_details/',
};

export const PO_ENDPOINTS = {
  GET_PO_DROPDOWN: '/v1.1/api-bills/dropdown/purchase_orders',
  GET_PO_DETAILS: '/v1.1/api-bills/dropdown/purchase_orders_details',
};

export const RESOURCE_ENDPOINTS = {
  GET_RESOURCE_DROPDOWN: '/v1.1/api-bills/dropdown/resources/',
  RESOURCE_LIBRARY_BULK_SAVE: 'v1.1/resources/library/bulk_save',
};

export const USER_ENDPOINTS = {
  GET_USERS: '/user/list',
  GET_APPROVERS: '/v1.1/api-bills/dropdown/approvers/',
};

export const TASK_ENDPOINTS = {
  GET_TASK_DROPDOWN: 'v1.1/api-bills/dropdown/tasks',
};

export const COST_CENTRES_ENDPOINTS = {
  GET_COST_CENTERS_DROPDOWN: 'v1.1/api-bills/dropdown/cost_centers/',
};

export const ACCOUNTING_CODE_ENDPOINTS = {
  GET_ACCOUNTING_CODE_DROPDOWN: 'v1.1/api-bills/dropdown/accounting_codes/',
};

export const COMMENT_ENDPOINTS = {
  GET_COMMENTS: '/bills/comment/list/',
  CREATE_COMMENT: '/bills/comment/create/',
  UPDATE_COMMENT: '/bills/comment/update/',
  DELETE_COMMENT: '/bills/comment/delete/',
};

export const ASSIGNED_BILL_ENDPOINTS = {
  GET_ASSIGNED_BILL: '/bills/dropdown/bills/',
};

export const ACCOUNT_INTEGRATION_ENDPOINTS = {
  QUICKBOOK: '/quick-book',
  QUICKBOOK_ORGANIZATION_DISCONNECT:
    '/integration/remove-quickbooks-organisation/',
  QUICKBOOK_PO_BILLS_DISCONNECT: '/integration/quickbooks-disconnect-po-bills/',
  QUICKBOOK_PO_INTEGRATION_SETTINGS: '/integration/quickbooks_posync_setting/',
  QUICKBOOK_BILL_INTEGRATION_SETTINGS: '/integration/quickbooks_bills_setting/',

  QUICKBOOK_AUTH_URL: '/integration/quickbooks-auth-url/',
  QUICKBOOK_ORGANIZATIONS: '/integration/quickbooks_organizations/',
  QUICKBOOK_PERIODIC_SYNC_SETTINGS:
    '/integration/quickbooks-periodic-sync-settings/',
  QUICKBOOK_SUPPLIER_SYNC: '/integration/sync-qb-suppliers/',
  QUICKBOOK_ACCOUNTING_CODE_SYNC: '/integration/sync-qb-accounting-codes/',
  QUICKBOOK_TAX_CODE_SYNC: '/integration/sync-qb-tax-type/',
  QUICKBOOK_REFRESH: '/integration/quickbooks-sync-organizations/',
  QUICKBOOK_TAX_TYPE_DROPDOWN: '/integration/quickbooks-tax-types/',
  QUICKBOOK_RESOURCE_DROPDOWN:
    '/integration/quickbooks-resource-expense-accounts/',
  QUICKBOOK_ACCOUNT_PAYABLE_DROPDOWN:
    '/integration/quickbooks-account-payable/',
  QUICKBOOK_PO_SYNC: '/integration/quickbooks_po_sync/',
  QUICKBOOK_BILL_SYNC: '/integration/quickbooks_bill_sync/',
  QUICKBOOK_PO_SYNC_STATUS: '/integration/quickbooks-sync-status/',
  QUICKBOOK_BILL_SYNC_STATUS: '/integration/quickbooks-bill-sync-status/',
};

export const INTEGRATIONS_ENDPOINTS = {
  GET_XERO_SIGNUP_URL: '/integration/get-xero-signup-url/',
  UPDATE_XERO_SIGNUP_FORM: '/integration/update-xero-signup-form',
  XERO_AUTH_URL: '/integration/xero-auth-url/',
};

export const ALLOWANCE_BASE_URL = '/v1.1/allowance/';

export const ALLOWANCE_ENDPOINTS = {
  LIST_ALLOWANCES: ALLOWANCE_BASE_URL,
  GET_ALLOWANCE: (id: string) => `${ALLOWANCE_BASE_URL}${id}/`,
  GET_ALLOWANCE_ASSIGNED_PROJECTS: (id: string) =>
    `${ALLOWANCE_BASE_URL}${id}/assigned_projects/`,
  RESTORE_ALLOWANCE: `${ALLOWANCE_BASE_URL}restore_allowance/`,
  GET_EMPLOYEE_ROLE: `${ALLOWANCE_BASE_URL}get_employee_role/`,
  DELETE_ALLOWANCE: (id: string) => `${ALLOWANCE_BASE_URL}${id}/`,
  ARCHIVE_ALLOWANCE: `${ALLOWANCE_BASE_URL}bulk_archive/`,
  BULK_DELETE_ALLOWANCE: `${ALLOWANCE_BASE_URL}bulk_delete/`,
  GET_ALLOWANCE_COST_CENTER: `${ALLOWANCE_BASE_URL}get_cost_center/`,
  GET_ALLOWANCE_EMPLOYEE_ROLE_LIST: `${ALLOWANCE_BASE_URL}get_employee_role/`,
  CREATE_ALLOWANCE: ALLOWANCE_BASE_URL,
  UPDATE_ALLOWANCE: (id: string) => `${ALLOWANCE_BASE_URL}${id}/`,
};

export const GLOBAL_ENDPOINTS = {
  COUNTRY: '/mobile/supplier/country/',
  STATE: '/state/',
  SAVE_ATTACHMENT: '/attachment/save_attachment/',
};
export const EMPLOYEE_BASE_URL = 'employee/';

export const EMPLOYEE_V1_BASE_URL = '/v1.1/employee/';

export const EMPLOYEE_ENDPOINTS = {
  LIST_EMPLOYEES: `${EMPLOYEE_V1_BASE_URL}`,
  GET_ALL_EMPLOYMENT_TYPES: `v1.1/employment_type/?per_page=5000`,
  EMPLOYEE_RESOURCE_CODES: EMPLOYEE_RESOURCE_CODES_API,
  GET_ALL_PAY_CATEGORIES: `v1.1/pay_category/?per_page=5000`,
  GET_EMPLOYEE: (id: string) => `${EMPLOYEE_BASE_URL}${id}/`,
  DELETE_EMPLOYEE: (id: string) => `${EMPLOYEE_BASE_URL}${id}/`,
  RESTORE_EMPLOYEE: (id: string) =>
    `${EMPLOYEE_BASE_URL}restore_employee/?employee_ids=${id}`,
  GET_ALL_EQUIPMENT_SUPPLIER: '/v1.1/equipment_supplier/',
  CREATE_EMPLOYEE: EMPLOYEE_BASE_URL,
  EDIT_EMPLOYEE: (id: string) => `${EMPLOYEE_BASE_URL}${id}/`,
  BULK_ARCHIEVE_EMPLOYEE: `${EMPLOYEE_V1_BASE_URL}bulk_archive/`,
  BULK_DELETE_EMPLOYEE: `${EMPLOYEE_V1_BASE_URL}bulk_delete/`,
  BULK_RESTORE_EMPLOYEE: `${EMPLOYEE_V1_BASE_URL}bulk_restore/`,
  RESET_PIN: `${EMPLOYEE_BASE_URL}send_pin_reset_link/`,
  GET_ALL_ALLOWANCE: `v1.1/allowance/`,
  REJECT_EMAIL: (id: string) =>
    `v1.1/email/reject_email_change_employee/?id=${id}`,
  REJECT_PHONE: (id: string) =>
    `v1.1/phone_number/reject_phone_change_employee/?id=${id}`,
  EXPORT_EMPLOYEE_EXCEL: `${EMPLOYEE_BASE_URL}export_employee/`,

  // this api end point will be changed once backend is ready
  GET_ALL_PROJECTS: `v1.1/daywork_dockets/dropdown/projects/?source=employee`,
  GET_RESOURCE_CODES: `/resource_code_list/employee_rate_sheet/`,
};

export const EMPLOYEE_TYPE_ENDPOINTS = {
  CREATE_EMPLOYMENT_TYPE: 'v1.1/employment_type/',
  EDIT_EMPLOYMENT_TYPE: (id: string) => `v1.1/employment_type/${id}/`,
};

export const PAY_CATEGORY_ENDPOINTS = {
  CREATE_PAY_CATEGORY: 'v1.1/pay_category/',
  EDIT_PAY_CATEGORY: (id: string) => `v1.1/pay_category/${id}/`,
};

export const DAYWORK_ENDPOINTS = {
  GENERATE_SUMAARY: '/v1.1/daywork_dockets/summary/',
};

export const EQUIPMENT_TYPE_BASE_URL = 'v1.1/equipment_type/';

export const EQUIPMENT_TYPE_ENDPOINTS = {
  EQUIPMENT_TYPE_ID: `${EQUIPMENT_TYPE_BASE_URL}:id/`,
  EQUIPMENT_TYPE_ARCHIVE: `${EQUIPMENT_TYPE_BASE_URL}bulk_archive/`,
  ASSIGNED_EQUIPMENT_TYPE: `${EQUIPMENT_TYPE_BASE_URL}:id/assigned_equipments/`,
  EQUIPMENT_TYPE_RESTORE: `${EQUIPMENT_TYPE_BASE_URL}restore/`,
  EQUIPMENT_TYPE_BULK_DELETE: `${EQUIPMENT_TYPE_BASE_URL}bulk_delete/`,
};
export const DASHBOARD_ENDPOINTS = {
  ASSIGNEE_OPTIONS: '/user/get-user-by-role/',
  SEGMENT_OPTIONS: '/v1.1/project_drop_down_segments/',
  CLIENT_OPTIONS: '/v1.1/project_drop_down_clients/',
  STATE_OPTIONS: '/state/',
  PROJECT_OPTIONS:
    '/v1.1/api-bills/dropdown/projects/?source=management_dashboard',
  PROJECT_BY_ID: (id: string) => `/project/${id}/`,
  PROJECT_DASHBOARD: (id: string) => `/project/${id}/new_project_dashboard/`,
  PROJECT_DASHBOARD_SETTINGS: `/v1.2/project-setting/`,
};

export const TIMESHEET_SETTINGS_ENDPOINTS = {
  GET_TIMESHEET_SETTINGS: '/v1.1/timesheet-settings/',
  GET_TIMESHEET_USERS: '/user/list',
  GET_PROJECT_TIMESHEET_SETTINGS: '/v1.1/project_timesheet_setting/list/',
  SAVE_PROJECT_TIMESHEET_SETTINGS: '/v1.1/project_timesheet_setting/save/',
};

export const AI_SUMMARY_ENDPOINTS = '/v1.1/ai/summarizer/';

export const AI_POLISH_TEXT = '/v1.1/ai/polish_text/';

export const SPOTLIGHT_ENDPOINT = '/v1.1/ai/global-search/';

export const TAG_GENERATION = '/v1.1/ai/tag_generation/';

export const FILE_NAME_GENERATION = '/v1.1/ai/filename_generation/';

export const COST_CENTRE_ENDPOINTS = {
  // GET endpoints
  LIST_COST_CENTRES: 'v1.1/cost_centre/list',
  GET_COST_CENTRE_BY_ID: (id: string) => `v1.1/cost_centre/get/${id}/`,
  GET_ASSIGNED_PROJECTS: (id: string) =>
    `v1.1/cost_centre/assigned_projects/${id}/`,
  EXPORT_COST_CENTRES: 'v1.1/cost_centre/export',
  IMPORT_TEMPLATE: 'v1.1/cost_centre/import_template',

  // POST endpoints
  CREATE_COST_CENTRE: 'v1.1/cost_centre/create/',
  IMPORT_COST_CENTRE: 'v1.1/cost_centre/import/',

  // PUT endpoints
  UPDATE_COST_CENTRE: (id: string) => `v1.1/cost_centre/update/${id}/`,
  RESTORE_COST_CENTRE: 'v1.1/cost_centre/restore/',

  // DELETE endpoints
  BULK_ARCHIVE_COST_CENTRE: 'v1.1/cost_centre/bulk_archive/',
  BULK_DELETE_COST_CENTRE: 'v1.1/cost_centre/bulk_delete/',
  BULK_RESTORE_COST_CENTRE: 'v1.1/cost_centre/restore/',
};

export const AI_BANNER_ENDPOINTS = {
  UPLOAD_FILE_TO_GOOGLE_DRIVE: '/project/upload_file_to_google_drive/',
};
